<template>
<div v-if="hide">

  <div class="editorial">
    <div class="editorial_nav">

      <div class="editorial_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="editorial_txt2">
          首页 <span class="span1">></span> <span class="span2">优先出版</span>
        </div>
      </div>
      
      <div class="editorial_left">
          <div class="express_rtitle">
            <div class="waike">优先出版</div>
            <div class="waixian"></div>
          </div>

        <div class="messageMain">

              <div class="cententMain" v-for="(item,index) in list" @click="down(item.channelId,item.contentId)">

                  <div   :class="item.zt?'add2':''" class="showLeft"  >
                  <span class="spanIndex" >{{index>=9?(index+1):"0"+(index+1)}}</span>
                  <!-- <span class="spanIndex" >1</span> -->
                  <span class="dataSpan">{{item.addDate}}</span>
                </div>

                  <li :class="item.zt?'add1':''"  @mouseover="addtop(1,item.contentId)"
    
            @mouseout="addtop(2,item.contentId)">{{item.title}}</li>

                  <span class="lookXq" :class="item.zt?'add1':''"  @mouseover="addtop(1,item.contentId)"
    
            @mouseout="addtop(2,item.contentId)"  style="text-decoration: underline;">查看详情 <span>></span> </span>
              </div>

        </div>


        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination> -->

      </div>
      <div class="editorial_right">
        <advertisement :num="num" :list2="list2"></advertisement>
      </div>
    </div>
  </div>
</div>

</template>

<script>
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components:{
    advertisement
  },
  data () {
    return {
      currentPage3: 1,//当前页数
      total: 0,//总条数
      hide:true,
      num:{
        wai: false,
        zixun: true,
        xia: true,
        look: false,
		video2: true,
      },//控制广告栏的显示隐藏
      list2: [

      ],//外科天地
      list:[
        
      ],
    }
  },

  methods:{
      index(){
        // this.total = this.list.length;
        this.GetHomePageBlockInfo(2748)

      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage3 = val;
        console.log(`当前页: ${val}`);
      },

    aaa(){

      Date.prototype.format = function(fmt) { 
     var o = { 
        "M+" : this.getMonth()+1,                 //月份 
        "d+" : this.getDate(),                    //日 
        "h+" : this.getHours(),                   //小时 
        "m+" : this.getMinutes(),                 //分 
        "s+" : this.getSeconds(),                 //秒 
        "q+" : Math.floor((this.getMonth()+3)/3), //季度 
        "S"  : this.getMilliseconds()             //毫秒 
    }; 
    if(/(y+)/.test(fmt)) {
            fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
    }
     for(var k in o) {
        if(new RegExp("("+ k +")").test(fmt)){
             fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
         }
     }
    return fmt; 
    }
    var time2 = new Date().format("yyyy.MM.dd");
 
    return time2
    },

     down(channelId,contentId){
       
      var that = this;
      that.$httphelper.GetContentInfo({
       "journalId": 201607080003,
        "year": 0,
        "issue": 0,
        "channelId": channelId,
        "contentId": contentId,
        "dataSourceType": 1,
        "dataShowType": 1
      }).then(res => {
        if(res.code==200){
          window.open(res.data.siteContentInfoResult.linkUrl);
          that.$loading.hideLoading();
        }else{
          that.$alert('没有附件', '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },

      GetHomePageBlockInfo(ChannelId){



      var that = this;
      that.$httphelper.GetHomePageBlockInfo({
        "journalId": 201607080003,
        "pChannelId": 0,
        "channelId": ChannelId,
        "jChannelID": 0,
        "dataSourceType": 1,
        "dataShowType": 1,
        "curr": that.curr,
        "limit": that.limit,
      }).then(res => {
        if(res.code==200){
          that.list = res.data || '';

          that.list.map((item,index)=>{
            item.addDate=item.addDate.replace(/-/g,'.')
          })
          that.total = res.totalcount;

          that.hide = true;
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        }
      });
    },

      addtop(num,id){
        if(num==1){
          for(var i=0;i<this.list.length;i++){
            if(id==this.list[i].contentId){
              this.list[i].zt = true;
              this.list.push('1');
              this.list.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.list.length;i++){
            this.list[i].zt = false;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      },
  },
  mounted(){

  },
  created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.editorial{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  .editorial_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    .editorial_txt{
      width: 100%;
      margin-top: 24px;
      margin-bottom: 26px;
      overflow: hidden;
      .evolution_tu{
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2{
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
    .editorial_left{
      width: 72%;
      margin-right: 3%;
      float: left;
      .messageMain{
        width: 100%;
        // border: 1px solid #ccc;

        .cententMain{
          width: 40%;
          cursor:pointer;
          margin-left: 75px;
          height: 140px;
          border: 1px solid #7D8CA3;
          float: left;
          text-align: center;
          position: relative;
          margin-top:50px;
          .showLeft{
            position: absolute;
            height: 69px;
            width: 69px;
            left: -40px;
            top: 45px;
            text-align: center;
            line-height: 34px;
            background-color: #767676;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #FFFFFF;
            .spanIndex{
              font-size: 20px;
            }
            .dataSpan{
              font-size: 10px;
            }
          }
            li{
              list-style-type: none;
              float: left;
              line-height: 30px;
              width: 70%;
              text-align: left;
              margin-left: 40px;
              margin-top: 50px;
              word-wrap:break-word;
            }
            .lookXq{
              position: absolute;
              top: 80px;
              right: 10px;
            }
        }

      }
      .express_rtitle {
        width: 100%;
        overflow: hidden;
        border-bottom: 3px solid #DBDBDB;
        padding-bottom: 11px;
        position: relative;
        .waike {
          width: 50%;
          float: left;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2A2D3E;
          line-height: 23px;
          margin-bottom: 20px;
        }
        .waixian {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100px;
          height: 3px;
          background: var(--biao);
        }
      }
      .express_nav2r {
        width: 100%;
        overflow: hidden;
        margin-top: 29px;
        .topContent{
           border: 1px solid #ccc;
           margin: 0 auto;
           width: 50%;
           height: 300px;
        }

        .express_list2 {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          margin-bottom: 12.3px;
          border-bottom: 1px solid #EBEBEB;
          line-height: 62px;
          .express_dian {
            width: 10px;
            height: 10px;
            background: #DBDBDB;
            border-radius: 50%;
            margin-right: 15px;
            float: left;
            margin-top: 27px;
          }

          .express_wen {
            width: 91%;
            float: left;

            .wen1 {
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;


              .span3 {
                width: 80%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                float: left;
              }
            }

            .wen2 {
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              margin-bottom: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          .zhai {
            width: 90%;
            padding-left: 31px;
            overflow: hidden;
            float: left;

            .wen3 {
              width: 50%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              float: left;
            }

            .zhai_left,
            .zhai_right {
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              float: right;
            }

            .zhai_right {
              margin-left: 30px;
            }

            .zhai_left:hover {
              text-decoration: underline;
              color: var(--biao);
            }

            .zhai_right:hover {
              text-decoration: underline;
              color: var(--biao);
            }
          }
        }
      }
      .el-pagination{
        text-align: center;
        margin-top: 30px;
      }
    }
    .editorial_right{
      width: 25%;
      float: left;
    }
  }
}
.add2{
  background-color: var(--xt)!important;
}
.add1{
     color: var(--xt) !important;
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/expert.vue